import { Attachment } from 'components/uploadDocs';
import { typedAction } from 'store/modules/base';

export const dataAditamento = (payload: string | undefined) => {
  return typedAction('cra/DATA_ADITAMENTO', payload);
};
export const dataAditamentoReset = () => {
  return typedAction('cra/DATA_ADITAMENTO/RESET');
};

export const uploadDocumentoAditamento = (payload: Attachment[]) => {
  return typedAction('cra/UPLOAD_DOCUMENTO_ADITAMENTO', payload);
};

export const uploadDocumentoAditamentoReset = () => {
  return typedAction('cra/UPLOAD_DOCUMENTO_ADITAMENTO/RESET');
};
export type AditamentoAction = ReturnType<
  | typeof dataAditamento
  | typeof dataAditamentoReset
  | typeof uploadDocumentoAditamento
  | typeof uploadDocumentoAditamentoReset
>;
